import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import Filter from './components/filter/filter';
import Content from './components/report-container/report-container';
import ReportsService from '../../../../services/reports-service';
import { IdentityContext } from '../../../../context/identity-context';
import './issuer-reports-module.scss';

const IssuerReportsModule = () => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState('All');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { user, role } = useContext(IdentityContext);
    const reportsService = new ReportsService();
    //console.log('user: ',user?.attributes?.['custom:entity_id']);

    useEffect(() => {
        const fetchReports = async () => {
            setLoading(true);
            setError(null); // Reset error state before making the request
            try {
                const response = await reportsService.getReports(role.toLowerCase(), user?.attributes?.['custom:entity_id']);
                console.log('Response data:', response.items);
                setItems(response.items); 
            } catch (err) {
                if (err.response) {
                    console.error('Error response data:', err.response.data);
                    console.error('Error response status:', err.response.status);
                    console.error('Error response headers:', err.response.headers);
                    setError(`Failed to load reports. Status: ${err.response.status}`);
                } else if (err.request) {
                    console.error('Error request data:', err.request);
                    setError('Failed to load reports. No response received.');
                } else {
                    console.error('Error message:', err.message);
                    setError('Failed to load reports. Error: ' + err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchReports();
    }, []); 

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    const handleFilterChange = (status) => {
        setFilter(status);
        // setSelectedItem(null); // Optionally clear selection when filter changes
    };

    return (
        <Container fluid className='issuer-reports-module-container'>
            <Row>
                <Col md={3} className="panel">
                    <Filter
                        items={items}
                        filter={filter}
                        onFilterChange={handleFilterChange}
                        onItemClick={handleItemClick}
                        selectedItem={selectedItem}
                    />
                </Col>
                <Col md={9}>
                    {loading && <Spinner animation="border" />}
                    {error && <Alert variant="danger">{error}</Alert>}
                    {!loading && !error && <Content selectedItem={selectedItem} />}
                </Col>
            </Row>
        </Container>
    );
};

export default IssuerReportsModule;
